// extracted by mini-css-extract-plugin
export var chevronIcon = "_ac-2";
export var teamName = "_ac-1";
export var teamSwitcherButton = "_ac-0";